import { render, staticRenderFns } from "./takeNumberResult.vue?vue&type=template&id=73156cac&scoped=true"
import script from "./takeNumberResult.vue?vue&type=script&lang=js"
export * from "./takeNumberResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73156cac",
  null
  
)

export default component.exports